import './index.css';

/*
 * Sep 23 2026 — the page's own script is a few kilobytes on purpose (perf/split-the-bundle).
 *
 * His link to the box drops to 5 to 8 KB/s, and the whole app used to be ONE file named by
 * its content: every deploy renamed it, so after every deploy he downloaded all of it again
 * (887 KB brotli) before anything painted. This file is the only one that has to change on
 * every deploy (it holds webpack's list of the other files' names). It asks for the app
 * (./bootstrap: App and everything the first screen needs); React and the other libraries
 * come as files of their own that keep their names until a library changes; and each
 * screen he has not opened yet comes when it is wanted (app/lazy/screens.tsx). The
 * browser keeps every file it already has, so a deploy costs what it changed.
 *
 * What ./bootstrap does is exactly what this file did: the crash screen around App, the
 * web vitals hook, and the service worker registered after load.
 */
import { loadTheApp } from './bootLoad';

/*
 * Oct 13 2026 (7.25) — /overlay/<look> is Greshy's OBS overlay page (overlay/page.ts): a download of its own, no
 * sign-in and no app. A download that fails is asked for again quietly; OBS shows nothing meanwhile, never an error.
 */
if (/^\/overlay\/sponsor-l3\/?$/.test(window.location.pathname)) {
  // Oct 20 2026 (7.50): the sponsor key's moving lower third (overlay/sponsorL3Page.ts), a download of its own too
  const go = (n: number): void => {
    import(/* webpackChunkName: "overlay-sponsor" */ './overlay/sponsorL3Page').then(
      (m) => m.startSponsorL3Page(),
      () => { window.setTimeout(() => go(n + 1), Math.min(30000, 2000 * (n + 1))); },
    );
  };
  go(0);
} else if (/^\/overlay\//.test(window.location.pathname)) {
  const go = (n: number): void => {
    import(/* webpackChunkName: "overlay" */ './overlay/page').then(
      (m) => m.startOverlayPage(),
      () => { window.setTimeout(() => go(n + 1), Math.min(30000, 2000 * (n + 1))); },
    );
  };
  go(0);
} else {
  loadTheApp(() => import(/* webpackChunkName: "app" */ './bootstrap'));
}
